// @ts-nocheck
import { populate } from 'populate';
import type { Container, Sprite, TilingSprite, Graphics, NineSlicePlane, Text } from 'pixi.js';

const raw = {
  list: [
    {
      id: '2a04a31e-25bf-4fca-b1b0-6eeb005d11d9',
      type: 'Container',
      name: 'root',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '',
      data: {
        rewardsSpacing: {
          x: 220,
          y: 260
        },
        separation: {
          thinSeparationTexture: 'Thin_Separation'
        }
      }
    },
    {
      id: '878d8c0b-4407-497d-8feb-b1fb4865ab2a',
      type: 'Sprite',
      name: '',
      className: '',
      x: 654,
      y: -254,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Screen',
      parent: '2a04a31e-25bf-4fca-b1b0-6eeb005d11d9',
      data: {
        DEBUG: true
      }
    },
    {
      id: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f',
      type: 'Container',
      name: 'content',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2a04a31e-25bf-4fca-b1b0-6eeb005d11d9'
    },
    {
      id: '8fd59c96-3e4e-4147-ac1e-270901e2b84b',
      type: 'Container',
      name: 'header',
      className: '',
      x: 0,
      y: 25,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2a04a31e-25bf-4fca-b1b0-6eeb005d11d9'
    },
    {
      id: 'b1cf8ffb-5c4d-43a1-b412-3811c911afb3',
      type: 'Container',
      name: 'timer',
      className: '',
      x: -8,
      y: -10,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '2a04a31e-25bf-4fca-b1b0-6eeb005d11d9'
    },
    {
      id: 'f5c85159-41a3-440a-9c87-39b97e2a47e6',
      type: 'Sprite',
      name: 'premiumColumnBackground',
      className: '',
      x: -2,
      y: 294,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 13.466667,
        y: 2.695418
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Premium_Column_Background',
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f'
    },
    {
      id: '97621b70-2561-4c7f-a42b-d017de8a8cff',
      type: 'Sprite',
      name: 'freeColumnBackground',
      className: '',
      x: 0,
      y: 294,
      anchor: {
        x: 1,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 13.466667,
        y: 2.695418
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Free_Column_Background',
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f'
    },
    {
      id: '3288bc00-0e3d-47ee-bd7a-74f6e9121f38',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: 'freeColumnPattern',
      className: '',
      x: -400,
      y: 290,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 4.081633,
        y: 6.896552
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 1846140,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Key_Pattern',
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f'
    },
    {
      id: 'c2609e3a-9339-4087-beb1-23190c379f50',
      type: 'Sprite',
      runtimeType: 'TilingSprite',
      name: 'premiumColumnPattern',
      className: '',
      x: 0,
      y: 290,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 4.081633,
        y: 6.66092
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 4327558,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Season_Pass_Key_Pattern',
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f'
    },
    {
      id: '3000aa06-38ba-41a6-a33a-bebb185fa94c',
      type: 'Container',
      name: 'contentSlotWrapper',
      className: '',
      x: 0,
      y: 284,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f'
    },
    {
      id: 'ae1ba165-204d-4f53-9aa1-0fb0c33fcbbd',
      type: 'Graphics',
      name: 'contentSlotMask',
      className: '',
      x: 0,
      y: 286,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f',
      commands: [
        {
          id: '88591aed-f904-4cab-9878-a321adc0f40a',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        },
        {
          id: 'd417861a-077a-4314-aa36-44ab80fec442',
          type: 'drawRect',
          x: -400,
          y: 0,
          width: 800,
          height: 1500
        },
        {
          id: '753ca736-0003-477f-97d1-4d02f1773178',
          type: 'beginFill',
          color: 16777215,
          alpha: 1
        }
      ]
    },
    {
      id: '19e12e78-9be0-48c6-b741-32cc4b6ceeb0',
      type: 'Sprite',
      name: 'scrollInput',
      className: '',
      x: 0,
      y: 289,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -400,
        y: 0,
        width: 800,
        height: 5000
      },
      texture: '',
      parent: 'cb134b82-f8a2-4a24-a26b-1d4c769f5d5f'
    },
    {
      id: 'a1f66280-c063-4885-83c8-9f41f7fb0ef0',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Top_UI_Background',
      parent: '8fd59c96-3e4e-4147-ac1e-270901e2b84b'
    },
    {
      id: '1334465f-7764-42de-9d26-e35ee7f03d98',
      type: 'Container',
      name: 'progressBarContainer',
      className: '',
      x: -210,
      y: 105,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8fd59c96-3e4e-4147-ac1e-270901e2b84b',
      stateByName: {
        premium: {
          x: -13
        }
      }
    },
    {
      id: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 172,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '8fd59c96-3e4e-4147-ac1e-270901e2b84b'
    },
    {
      id: '7f2365f4-e103-475a-aeb7-19ccecb48c6b',
      type: 'NineSlicePlane',
      name: 'frame',
      className: 'props_SPL',
      x: -415,
      y: -3,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      width: 830,
      height: 1570,
      leftWidth: 30,
      topHeight: 30,
      rightWidth: 30,
      bottomHeight: 35,
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Frame_Gold_9Slice_30_30_30_35',
      parent: '8fd59c96-3e4e-4147-ac1e-270901e2b84b',
      data: {
        props: {
          eventMode: 'none'
        }
      }
    },
    {
      id: '6bc63185-c1ad-4b24-ac30-016632e77cbf',
      type: 'Container',
      name: 'buyPremiumButton',
      className: '',
      x: 220,
      y: 173,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: true,
      buttonMode: true,
      hitArea: {
        type: 'Rectangle',
        x: -130,
        y: -134,
        width: 260,
        height: 220
      },
      parent: '8fd59c96-3e4e-4147-ac1e-270901e2b84b',
      stateByName: {
        premium: {
          visible: false
        }
      }
    },
    {
      id: 'c59b4112-ed88-4e1b-9ee0-7f15bc20f264',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 43,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0.3,
      visible: true,
      tint: 0,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: 'b1cf8ffb-5c4d-43a1-b412-3811c911afb3'
    },
    {
      id: '0cfbf070-6d47-42bc-83bb-34b2de2e3c69',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Timer_Background',
      parent: 'b1cf8ffb-5c4d-43a1-b412-3811c911afb3'
    },
    {
      id: '509cf4d2-10f2-46bf-811d-450b1f158545',
      type: 'Sprite',
      name: 'clockIcon',
      className: '',
      x: -95,
      y: 40,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 0.85,
        y: 0.85
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Golden_Clock',
      parent: 'b1cf8ffb-5c4d-43a1-b412-3811c911afb3'
    },
    {
      id: '8769e23f-2734-49fd-b712-6b02b64250c6',
      type: 'Text',
      name: 'timerText',
      className: '',
      x: 6,
      y: 38,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '1d 20h',
      localize: false,
      maxWidth: 147,
      maxHeight: 54,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 34,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: false,
        dropShadowAlpha: 1,
        dropShadowAngle: 0,
        dropShadowBlur: 0,
        dropShadowColor: 'black',
        dropShadowDistance: 5,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'b1cf8ffb-5c4d-43a1-b412-3811c911afb3'
    },
    {
      id: 'dc41fcce-2c58-4eb7-bc73-67750e416750',
      type: 'Container',
      name: 'contentSlot',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '3000aa06-38ba-41a6-a33a-bebb185fa94c'
    },
    {
      id: '0e4be7f4-08f7-4c71-a103-b20772c4a316',
      type: 'Container',
      name: '',
      className: '',
      x: 0,
      y: 0,
      scale: {
        x: 1,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      angle: 0,
      alpha: 1,
      visible: true,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      parent: '1334465f-7764-42de-9d26-e35ee7f03d98'
    },
    {
      id: '25676755-0646-4841-a923-f3b62ed124a8',
      type: 'Sprite',
      name: 'progressBarKey',
      className: '',
      x: -129,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Key',
      parent: '1334465f-7764-42de-9d26-e35ee7f03d98'
    },
    {
      id: '5c97fb9f-bbdf-4590-9361-a2a42f961a62',
      type: 'Sprite',
      name: 'progressBarNode',
      className: '',
      x: 130,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Big_Blue_Node',
      parent: '1334465f-7764-42de-9d26-e35ee7f03d98',
      stateByName: {
        vaultProgressBar: {
          visible: true,
          texture: 'Vault_Coin_Icon'
        }
      }
    },
    {
      id: 'bae69e35-cb51-4f88-8350-0fe3b50dd876',
      type: 'Text',
      name: 'progressBarTier',
      className: '',
      x: 132,
      y: -5,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '3',
      localize: false,
      maxWidth: 47,
      maxHeight: 66,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 49,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1242C0',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1242C0',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '1334465f-7764-42de-9d26-e35ee7f03d98',
      stateByName: {
        vaultProgressBar: {
          visible: false
        }
      }
    },
    {
      id: '5db830c9-6c46-4800-8ceb-cf51daa91882',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: -1,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 81.1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Free_Premium_Background',
      parent: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7'
    },
    {
      id: '4abe6f04-97e0-4bbf-8cce-ccbda0d04fc5',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Free_Premium_Background_Separation',
      parent: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7'
    },
    {
      id: '2b8ca0b5-b260-4125-9e26-df05b8cf92ab',
      type: 'Sprite',
      name: '',
      className: '',
      x: -218,
      y: 49,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Free_Ticket',
      parent: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7'
    },
    {
      id: '5eef40e5-e751-4771-8e7a-e3b7ce447a52',
      type: 'Text',
      name: '',
      className: '',
      x: -218,
      y: 45,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Free',
      localize: true,
      maxWidth: 163,
      maxHeight: 64,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#143AAA',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 2,
        dropShadowColor: '#78F3FA',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7'
    },
    {
      id: '2f791ae7-f383-495f-8602-eb5771422317',
      type: 'Sprite',
      name: '',
      className: '',
      x: 219,
      y: 50,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Premium_Ticket',
      parent: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7'
    },
    {
      id: '445de04c-aef1-4c77-8503-5e09299aaa40',
      type: 'Text',
      name: '',
      className: '',
      x: 220,
      y: 44,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Premium',
      localize: true,
      maxWidth: 177,
      maxHeight: 64,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 36,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: '#7D2726',
        stroke: 'black',
        strokeThickness: 0,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 2,
        dropShadowColor: '#FFFA77',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: 'f9a47bb9-7cd3-476c-be34-fc00f275f2c7'
    },
    {
      id: 'c66f3633-c4ea-43ce-919b-b922dc5354dc',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Activate_Button',
      parent: '6bc63185-c1ad-4b24-ac30-016632e77cbf'
    },
    {
      id: '32a06421-4dfe-45d7-8d4d-bf53bd97d690',
      type: 'Sprite',
      name: 'premiumButtonOverlay',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 1
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 0,
      visible: true,
      tint: 16777215,
      blendMode: 1,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Activate_Button',
      parent: '6bc63185-c1ad-4b24-ac30-016632e77cbf'
    },
    {
      id: '75d51930-d9bc-4e26-bafb-a93f8aed92aa',
      type: 'Text',
      name: '',
      className: '',
      x: 0,
      y: -83,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: 'Activate',
      localize: true,
      maxWidth: 0,
      maxHeight: 0,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 48,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#1A592D',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#1A592D',
        dropShadowDistance: 2,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '6bc63185-c1ad-4b24-ac30-016632e77cbf'
    },
    {
      id: '88821aec-3c60-4c83-995b-4b183c71e6da',
      type: 'Sprite',
      name: 'verticalBarBackground',
      className: 'props_SPL',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1.98939
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Vertical_Progress_Bar_Empty',
      parent: 'dc41fcce-2c58-4eb7-bc73-67750e416750',
      data: {
        props: {
          eventMode: 'none',
          zIndex: 30
        }
      }
    },
    {
      id: '88d318ae-d012-485a-92a2-76524e9bf367',
      type: 'Sprite',
      name: 'verticalBarFill',
      className: 'props_SPL',
      x: 0,
      y: -200,
      anchor: {
        x: 0.5,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1.98939
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Vertical_Progress_Bar_Full',
      parent: 'dc41fcce-2c58-4eb7-bc73-67750e416750',
      data: {
        props: {
          eventMode: 'none',
          zIndex: 31
        }
      }
    },
    {
      id: '99cf1569-286d-45e8-9bb2-e306bdcd710c',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Progress_Bar_Background',
      parent: '0e4be7f4-08f7-4c71-a103-b20772c4a316'
    },
    {
      id: '9b163d80-e71e-4a7f-928d-5078e06f1f73',
      type: 'Sprite',
      name: 'progressBar',
      className: '',
      x: -131,
      y: -33,
      anchor: {
        x: 0,
        y: 0
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Progress_Bar_Full',
      parent: '0e4be7f4-08f7-4c71-a103-b20772c4a316'
    },
    {
      id: '89310a63-a3d1-4305-89ce-b42aa1f469e8',
      type: 'Sprite',
      name: '',
      className: '',
      x: 0,
      y: 0,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      pivot: {
        x: 0,
        y: 0
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      tint: 16777215,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      texture: 'Progress_Bar_Top',
      parent: '0e4be7f4-08f7-4c71-a103-b20772c4a316'
    },
    {
      id: '4ffe9c0e-da61-4eb4-a175-4c8c5c14c2fa',
      type: 'Text',
      name: 'progressBarLabel',
      className: '',
      x: 1,
      y: -3,
      anchor: {
        x: 0.5,
        y: 0.5
      },
      scale: {
        x: 1,
        y: 1
      },
      angle: 0,
      alpha: 1,
      visible: true,
      blendMode: 0,
      interactive: false,
      buttonMode: false,
      hitArea: {
        type: 'None'
      },
      text: '2/3',
      localize: false,
      maxWidth: 167,
      maxHeight: 93,
      maxFontSize: 0,
      icons: [],
      style: {
        fontSize: 50,
        fontWeight: 'normal',
        fontFamily: 'Baloo{wf}',
        fill: 'white',
        stroke: '#19582A',
        strokeThickness: 5,
        align: 'left',
        wordWrap: false,
        wordWrapWidth: 100,
        breakWords: false,
        lineHeight: 0,
        padding: 0,
        fontStyle: 'normal',
        dropShadow: true,
        dropShadowAlpha: 1,
        dropShadowAngle: 1.57,
        dropShadowBlur: 0,
        dropShadowColor: '#19582A',
        dropShadowDistance: 1,
        leading: 0,
        lineJoin: 'round',
        miterLimit: 10,
        trim: false,
        textBaseline: 'alphabetic',
        whiteSpace: 'pre',
        fontVariant: 'normal',
        letterSpacing: 0,
        fillGradientStops: [],
        fillGradientType: 0
      },
      parent: '0e4be7f4-08f7-4c71-a103-b20772c4a316'
    }
  ],
  x: 0,
  y: 0,
  width: 760,
  height: 760,
  version: '3.1.0',
  stateNames: [
    'premium',
    'vaultProgressBar'
  ],
  animations: [
    {
      id: 'db289815-37cb-4603-99af-fba9c2eaa6bb',
      name: 'Idle_Clock',
      playingSpeed: 1,
      totalDuration: 1000,
      blocks: [
        {
          id: '29a2d504-533b-43f5-9f7e-91da138d5985',
          type: 'Tween',
          name: 'New_tween',
          duration: 500,
          track: 2,
          target: {
            scale: {
              x: 0.87,
              y: 0.87
            }
          },
          startAt: 0,
          sourceName: 'clockIcon',
          easing: 'SinusoidalOut',
          disabled: false
        },
        {
          id: 'fc4a2875-7bcd-4972-9286-1465d0c60556',
          type: 'Tween',
          name: 'New_tween_copy_1',
          duration: 500,
          track: 2,
          target: {
            scale: {
              x: 0.85,
              y: 0.85
            }
          },
          startAt: 500,
          sourceName: 'clockIcon',
          easing: 'SinusoidalOut',
          disabled: false
        }
      ]
    },
    {
      id: 'a2e4a9b9-3011-4b10-bfd6-f7353b5ef352',
      name: 'Idle_BuyButton',
      playingSpeed: 1,
      totalDuration: 2000,
      blocks: [
        {
          id: '806f415a-c6bb-49d1-9d88-f44a87338f89',
          type: 'Tween',
          name: 'New_tween_1',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1.03,
              y: 1.03
            }
          },
          startAt: 0,
          sourceName: 'buyPremiumButton',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'a7470bba-fe49-4db4-a855-fa19c33f3f54',
          type: 'Tween',
          name: 'New_tween_1_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {},
            alpha: 0.2
          },
          startAt: 0,
          sourceName: 'premiumButtonOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'bc58afaa-209e-4c25-98bb-435da7c3bf70',
          type: 'Tween',
          name: 'New_tween_1_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {},
            alpha: 0
          },
          startAt: 200,
          sourceName: 'premiumButtonOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: 'f0014829-5c7a-4f7f-a4a9-9f738cdcd3ab',
          type: 'Tween',
          name: 'New_tween_1_copy_1',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 200,
          sourceName: 'buyPremiumButton',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '1ba63dca-8a6e-4095-ae58-eef1df984a70',
          type: 'Tween',
          name: 'New_tween_1_copy_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {},
            alpha: 0.2
          },
          startAt: 400,
          sourceName: 'premiumButtonOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '25b3b716-90db-4a8d-afc4-e602bfc12e87',
          type: 'Tween',
          name: 'New_tween_1_copy_1_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1.02,
              y: 1.02
            }
          },
          startAt: 400,
          sourceName: 'buyPremiumButton',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: '6bbca443-abbf-41af-bb54-c518e3353346',
          type: 'Tween',
          name: 'New_tween_1_copy_copy_copy_copy',
          duration: 200,
          track: 2,
          target: {
            scale: {},
            alpha: 0
          },
          startAt: 600,
          sourceName: 'premiumButtonOverlay',
          easing: 'SinusoidalIn',
          disabled: false
        },
        {
          id: '077026f1-c26f-432d-8fae-54688bc1bd4b',
          type: 'Tween',
          name: 'New_tween_1_copy_1_copy_1',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 600,
          sourceName: 'buyPremiumButton',
          easing: 'SinusoidalInOut',
          disabled: false
        },
        {
          id: 'fd35d52c-6f4f-4c1e-a185-b2f283b09f3d',
          type: 'Tween',
          name: 'New_tween_1_copy_1_copy_1_copy',
          duration: 200,
          track: 4,
          target: {
            scale: {
              x: 1,
              y: 1
            }
          },
          startAt: 800,
          sourceName: 'buyPremiumButton',
          easing: 'SinusoidalInOut',
          disabled: false
        }
      ]
    }
  ],
  handleResize: false
} as const;

export class SeasonPassTrackLayout {
  static raw = raw;
  root!: Container & { data: typeof raw['list'][0]['data'] };
  content!: Container;
  header!: Container;
  timer!: Container;
  premiumColumnBackground!: Sprite;
  freeColumnBackground!: Sprite;
  freeColumnPattern!: TilingSprite;
  premiumColumnPattern!: TilingSprite;
  contentSlotWrapper!: Container;
  contentSlotMask!: Graphics;
  scrollInput!: Sprite;
  progressBarContainer!: Container;
  frame!: NineSlicePlane & { data: typeof raw['list'][15]['data'] };
  buyPremiumButton!: Container;
  clockIcon!: Sprite;
  timerText!: Text;
  contentSlot!: Container;
  progressBarKey!: Sprite;
  progressBarNode!: Sprite;
  progressBarTier!: Text;
  premiumButtonOverlay!: Sprite;
  verticalBarBackground!: Sprite & { data: typeof raw['list'][35]['data'] };
  verticalBarFill!: Sprite & { data: typeof raw['list'][36]['data'] };
  progressBar!: Sprite;
  progressBarLabel!: Text;
  props_SPL!: (NineSlicePlane & { data: typeof raw['list'][15]['data'] } | Sprite & { data: typeof raw['list'][35]['data'] } | Sprite & { data: typeof raw['list'][36]['data'] })[];
  StateName!: 'premium' | 'vaultProgressBar';

  constructor() {
    populate(this, raw);
  }
}

export abstract class Idle_Clock {
  Layout: {
    clockIcon: object;
  };

  BlockTypeByName: {
    New_tween: object;
    New_tween_copy_1: object;
  };

  flowData = raw.animations[0];
}

export abstract class Idle_BuyButton {
  Layout: {
    buyPremiumButton: object;
    premiumButtonOverlay: object;
  };

  BlockTypeByName: {
    New_tween_1: object;
    New_tween_1_copy: object;
    New_tween_1_copy_copy: object;
    New_tween_1_copy_1: object;
    New_tween_1_copy_copy_copy: object;
    New_tween_1_copy_1_copy: object;
    New_tween_1_copy_copy_copy_copy: object;
    New_tween_1_copy_1_copy_1: object;
    New_tween_1_copy_1_copy_1_copy: object;
  };

  flowData = raw.animations[1];
}
